import axios from "axios";
import { Toast } from "vant";
import router from "../router";

import { app } from "../main.js";
import { getCurrentInstance, ref } from "vue";
import { getRouterStore } from "../store";
const currentInstance = getCurrentInstance();
const proxy = ref(currentInstance?.proxy);
// 请求  baseURL: "/api"  本地连接调试
// win注释 正式地址
// 请求  baseURL: "https://point-store.api.taohualian168.net/api", 正式
const request = axios.create({
  baseURL: "https://point-store.api.taohualian168.net/api",
  // 测试地址
  // baseURL: "https://point-store.dev.api.taohualian168.net/api",
  // baseURL: "/api",
  timeout: 300000,
});

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(
  (config) => {
    let user = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(user, "user");
    if (config && config.headers) {
      config.headers["Content-Type"] = "application/json;charset=utf-8";
    }
    if (user != null) {
      config.headers["Authorization"] = "Bearer " + user.token; // 设置请求头
    }
    // config.headers["Authorization"] = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmYWtlX3VzZXJfaWQiLCLlhazlj7jnvJbnoIEiOiJ0aHNiIiwi5YWs5Y-45Zyw5Z2AIjoiaHR0cHM6Ly9vcGVuLndlaXhpbi5xcS5jb20vY29ubmVjdC9vYXV0aDIvYXV0aG9yaXplP2FwcGlkPXd4NDY3ZjBkODA2MTNlZjExNSZyZWRpcmVjdF91cmk9aHR0cHMlM0ElMkYlMkZ0ZXN0eWd3Lm0udGFvaHVhc2FuYmFvLmNvbSUyRnJlZGlyZWN0JnJlc3BvbnNlX3R5cGU9Y29kZSZzY29wZT1zbnNhcGlfdXNlcmluZm8mc3RhdGU9LyN3ZWNoYXRfcmVkaXJlY3QiLCLlhazlj7jlkI3np7AiOiLmoYPoirHkuInlrp0iLCLnlKjmiLflkI3np7AiOiJ3aW4iLCLnlKjmiLdJZCI6IjQzNDU5OTg1MjQ0OTY3NDAzNTIiLCLnlKjmiLflpLTlg48iOiJodHRwczovL3RoaXJkd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL1EwajRUd0dUZlRMT2liVG1LdGlhekdZQXR0SmVGNDVPTWhlRXVhTFJkaWNySTVUcjFlN1RSdGRFYnpGc1pJNWljTGUxbFBGMjhXakRmTHdjcEJrT2gzRVZwZy8xMzIiLCJuYmYiOjE3MzA3OTA3NTcsImV4cCI6MTczMDg3NzE1NywiaXNzIjoiV2ViQXBwSXNzdWVyIiwiYXVkIjoiV2ViQXBwQXVkaWVuY2UifQ.E-6vw5VV-cOgfWZCqJQBfOI2g4pUXfdDUjTfo0T30hg"// 设置请求头

    // if (userInfo && userInfo.token && userInfo.isLogin) {
    //   config.headers["Authorization"] = "Bearer " + user.token;
    // }
    config.headers.shopid = 2;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  (response) => {

    let res = response.data;
    // console.log(response);
    // Toast.fail("服务端异常！");
    if (response.status === 200) {
      return Promise.resolve(res);
    }
    // 如果是返回的文件
    if (response.status === 401) {
      // Toast.fail('服务端异常！')
      // if (router.currentRoute.path !== '/login') {
      //     router.replace({ path: '/login' })
      // }
      return Promise.reject(res.errors);
    }
    if (response.status === 403) {
      // Toast.fail('服务端异常！')
      // if (router.currentRoute.path !== '/login') {
      //     router.replace({ path: '/login' })
      // }
      return Promise.reject(res.errors);
    }
    if (response.status === 429) {
      return Promise.reject(res.errors);
    }
    if (response.status === 404) {
      router.replace({ path: "/error" });
    }
    if (response.status === 400) {
      router.replace({ path: "/error" });
    }
    if (response.config.responseType === "blob") {
      return res;
    }
    // 兼容服务端返回的字符串数据
    if (typeof response === "string") {
      // console.log(res, "返回字符串");
      res = res ? JSON.parse(res) : res;
    }
    if (response.status === 500) {
      // Toast.fail("服务端异常！");
      router.replace({ path: "/error" });
      return Promise.reject(res.errors);
    }
    return res;
  },
  (error) => {
    console.log(error, 96)
    console.log(error.response, 97)
    if (error.response && error.response.status === 429) {
      Toast.fail(error.response.data.msg)
    } else {
      router.replace({ path: "/error" });
      return Promise.reject(error);
    }
    // Toast.fail("服务端异常！");

  }
);

export default request;
